const doc = [({"zh_tw":({"adminConstantHotelCheckInRequiredGuestInfoScope":({"allGuests":"所有客人", "onlyRepresentative":"僅代表"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;